/* 🤖 this file was generated by svg-to-ts */
export const matIconCardMembership: {
  name: 'card-membership';
  data: string;
} = {
  name: 'card-membership',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"/></svg>`
};
